import { MIXPANEL_PROGRAM_TYPE } from "@src/constants/analyticsTracking";

const MIXPANEL_PROGRAM_TYPE_ALIASES: Record<string, string> = {
  "Student Introduction": MIXPANEL_PROGRAM_TYPE.STUDENT_INTRODUCTION,
  [MIXPANEL_PROGRAM_TYPE.STUDENT_INTRODUCTION]:
    MIXPANEL_PROGRAM_TYPE.STUDENT_INTRODUCTION,
  "Educator Wellbeing": MIXPANEL_PROGRAM_TYPE.EDUCATOR_WELL_BEING_SERIES,
  [MIXPANEL_PROGRAM_TYPE.EDUCATOR_WELL_BEING_SERIES]:
    MIXPANEL_PROGRAM_TYPE.EDUCATOR_WELL_BEING_SERIES,
  [MIXPANEL_PROGRAM_TYPE.STUDENT_VOICE_SERIES]:
    MIXPANEL_PROGRAM_TYPE.STUDENT_VOICE_SERIES,
  [MIXPANEL_PROGRAM_TYPE.LESSON_LIBRARY]:
    MIXPANEL_PROGRAM_TYPE.LESSON_LIBRARY,
  [MIXPANEL_PROGRAM_TYPE.PROFESSIONAL_DEVELOPMENT]:
    MIXPANEL_PROGRAM_TYPE.PROFESSIONAL_DEVELOPMENT,
  [MIXPANEL_PROGRAM_TYPE.TRANSITIONS]: MIXPANEL_PROGRAM_TYPE.TRANSITIONS,
  [MIXPANEL_PROGRAM_TYPE.BRAIN_BREAKS]: MIXPANEL_PROGRAM_TYPE.BRAIN_BREAKS,
  [MIXPANEL_PROGRAM_TYPE.SKILL_BUILDERS]: MIXPANEL_PROGRAM_TYPE.SKILL_BUILDERS,
  [MIXPANEL_PROGRAM_TYPE.CREATING_RESILIENT_CLASSROOMS]:
    MIXPANEL_PROGRAM_TYPE.CREATING_RESILIENT_CLASSROOMS,
};

export const normalizeMixpanelProgramType = (value?: string | null): string => {
  if (!value) return "";
  return MIXPANEL_PROGRAM_TYPE_ALIASES[value] || value;
};

type ResolveMixpanelProgramTypeArgs = {
  programName?: string | null;
  courseName?: string | null;
  unitName?: string | null;
};

export const resolveMixpanelProgramType = ({
  programName,
  courseName,
  unitName,
}: ResolveMixpanelProgramTypeArgs): string => {
  return (
    normalizeMixpanelProgramType(programName) ||
    normalizeMixpanelProgramType(courseName) ||
    normalizeMixpanelProgramType(unitName)
  );
};

